import {
	Http
} from '../utils/http'
import {
	cache
} from '@/utils/cache';
import {
	config
} from '@/config';

class GoodsModel extends Http {
	constructor() {
		super();
		this._storageKey += 'goods_';
	}
	getList(start = 0, count = 10) {
		const key = `${this._storageKey}lists_${start}_${count}`
		const data = cache.get(key)
		if (data) {
			return this._returnPromise(data)
		} else {
			return this.request({
				url: '/goods/lists',
				data: {
					start,
					count
				}
			}).then((res) => {
				// const data = res ? res.data : []
				const data = res
				cache.set(key, data, cache.expireIn)
				return this._returnPromise(data)
			})
		}
	}
	search(start, q, count = 10) {
		return this.request({
			url: '/goods/search?summary=1',
			data: {
				q,
				start,
				count
			}
		})
	}
	getDetail(id) {
		const key = `${this._storageKey}${id}`
		const product = cache.get(key)

		if (product)
			return this._returnPromise(product)
		else
			return this.request({
				url: `/goods/detail/${id}`
			}).then((res) => {
				if (res) {
					res.goods_content = res.goods_content.replace(/\<img/g, '<img style="width:100%;height:auto;" ')
					res.goods_content = res.goods_content.replace(/\/ueditor\/php/g, `${config.domain}/ueditor/php`)
					res.goods_content = res.goods_content.replace(/lxtx.com/g, `${config.host}`)
				}

				cache.set(key, res, cache.expireIn)
				return this._returnPromise(res)
			})
	}

	getBuyNowData(id, spec_key, count) {
		const keys = ['id', 'name', 'market_price', 'shop_price', 'original_img', 'selling_point', 'thumb_img']

		return this.getDetail(id).then(res => {
			let key_name = this._getSpecKeyName(res, spec_key),
				data = objGetSomeKeys(res, keys)
			return [{
				...data,
				spec_key,
				key_name,
				count
			}]
		})
	}

	_getSpecKeyName(goods, spec_key = '') {
		const all_spec_info = goods.spec_price_stock,
			hasSpec = all_spec_info && all_spec_info.length
		let key_name = ''
		if (hasSpec && spec_key) {
			for (var i in all_spec_info) {
				if (spec_key == all_spec_info[i].key) {
					key_name = all_spec_info[i].key_name
					break
				}
			}
		}
		return key_name
	}
}
export {
	GoodsModel
}
